import { create } from 'zustand';
import { getMusicGenre } from '../services';

export interface MoodOption {
  label: string;
  value: string;
}

interface MoodState {
  // 数据
  moodOptions: MoodOption[];
  isLoaded: boolean;
  isLoading: boolean;
  
  // Actions
  fetchMoods: () => Promise<void>;
  reset: () => void;
}

export const useMoodStore = create<MoodState>((set, get) => ({
  moodOptions: [],
  isLoaded: false,
  isLoading: false,

  fetchMoods: async () => {
    // 如果已加载或正在加载，跳过
    if (get().isLoaded || get().isLoading) return;
    
    set({ isLoading: true });
    
    try {
      const res: any = await getMusicGenre();
      const moodMap = res?.moodMap || res?.data?.moodMap || {};
      
      // 转换为 options 格式
      const moodOptions: MoodOption[] = Object.entries(moodMap).map(([id, name]) => ({
        label: name as string,
        value: id,
      }));
      
      set({
        moodOptions,
        isLoaded: true,
        isLoading: false,
      });
    } catch (error) {
      console.error('Failed to fetch moods:', error);
      set({ isLoading: false });
    }
  },

  reset: () => set({
    moodOptions: [],
    isLoaded: false,
    isLoading: false,
  }),
}));

// 便捷函数
export const getMoodOptions = () => useMoodStore.getState().moodOptions;
export const fetchMoodsIfNeeded = () => useMoodStore.getState().fetchMoods();
